<template>
    <div class="apprentice-simple-card">
        <div
            class="row"
            style="margin-bottom: 30px">
            <div class="col-md-2">
                Provider: {{ lasLocation.provider }} <br />
                Naam: {{ lasLocation.name }} <br />
            </div>
            <div class="col-md-6 text-right">
                <span
                    v-if="teachers.length || students.length"
                    style="margin-right: 10px">
                    <button
                        class="btn btn-primary"
                        @click="showAttachByName">
                        {{ $t('school.link_by_name') }}
                    </button>
                    <button
                        class="btn btn-primary"
                        v-if="uncheckedTeachers.length || uncheckedStudents.length"
                        @click="createUsers()">
                        {{ $t('school.create_other_users') }}
                    </button>
                    <button
                        class="btn btn-outline-success"
                        v-else
                        disabled>
                        {{ $t('school.all_users_are_linked') }}
                    </button>

                    <design-2021-school-las-attach-by-name-modal
                        ref="attach-by-name"
                        :unchecked-students-in="uncheckedStudents"
                        :unchecked-user-students-in="uncheckedUserStudents"
                        :unchecked-teachers-in="uncheckedTeachers"
                        :unchecked-user-teachers-in="uncheckedUserTeachers"
                        @update-students="updateStudents($event)"
                        @update-teachers="updateTeacher($event)"></design-2021-school-las-attach-by-name-modal>
                </span>

                <button
                    class="btn btn-primary"
                    v-if="!lasLocation.manually_verified"
                    @click="checkSchool">
                    {{ $t('school.round_this_location') }}
                </button>
                <button
                    class="btn btn-outline-success"
                    v-else
                    disabled>
                    {{ $t('school.school_is_completed') }}
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <b-tabs
                    v-model="tabIndex"
                    content-class="mt-3">
                    <b-tab
                        class="apprentice-tab"
                        title="LAS-gegevens">
                        <design-2021-school-las-location-edit-component
                            :las-location-in="lasLocation"
                            @lasLocationUpdated="updateLasLocation"></design-2021-school-las-location-edit-component>
                    </b-tab>
                    <b-tab
                        class="apprentice-tab"
                        :title="$t('school.students')"
                        active>
                        <div class="row">
                            <div class="col-md-4">
                                <div
                                    class="card"
                                    style="padding: 5px">
                                    <div class="card-title text-center">
                                        {{ $t('school.linked_students') }} ({{ checkedStudents.length }})
                                    </div>

                                    <div class="card-body">
                                        <ul>
                                            <li
                                                class="clickable-item"
                                                v-for="student of checkedStudents"
                                                @click="detachStudent(student)"
                                                style="margin-bottom: 10px">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <b>{{ student.full_name }}</b>
                                                        <span
                                                            class="no-eck-id-warning"
                                                            v-if="!student.eck_id"
                                                            >{{ $t('school.no_eck_id') }}</span
                                                        ><br />
                                                        <i>(las) {{ student.email }}</i> <br />
                                                        <i>(pxm) {{ getUserEmail(student.user_id) }}</i>
                                                    </div>
                                                    <div class="col-md-2"><i class="fa fa-trash"></i></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div
                                    class="card"
                                    style="padding: 5px">
                                    <div class="card-title text-center">
                                        {{ $t('school.unlinked_students') }} ({{ uncheckedStudents.length }})
                                    </div>

                                    <div class="card-body">
                                        <ul>
                                            <li
                                                class="clickable-item"
                                                v-for="student of uncheckedStudents"
                                                @click="selectStudent(student)"
                                                :style="[
                                                    selectedStudent && student.id === selectedStudent.id
                                                        ? { 'background-color': 'green' }
                                                        : '',
                                                ]"
                                                style="margin-bottom: 10px">
                                                <div class="col-md-10">
                                                    <b>{{ student.full_name }}</b>
                                                    <span
                                                        class="no-eck-id-warning"
                                                        v-if="!student.eck_id"
                                                        >{{ $t('school.no_eck_id') }}</span
                                                    ><br />
                                                    <i>{{ student.email }}</i>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div
                                    class="card"
                                    style="padding: 5px">
                                    <div class="card-title text-center">
                                        {{ $t('school.unlinked_existing_students') }} ({{
                                            uncheckedUserStudents.length
                                        }})
                                    </div>

                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-12 text-center">
                                                        <b>{{ $t('school.suggestions') }}</b>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul>
                                                            <li
                                                                class="clickable-item"
                                                                v-for="user of suggestedUserStudents"
                                                                @click="connectUserStudent(user)"
                                                                style="margin-bottom: 10px">
                                                                <div>
                                                                    <b>{{ user.full_name }}</b
                                                                    ><br />
                                                                    <i>{{ user.email }}</i>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div
                                                    class="row"
                                                    style="margin-top: 20px">
                                                    <div class="col-md-12 text-center">
                                                        <b>{{ $t('school.all_students') }}</b>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul>
                                                            <li
                                                                class="clickable-item"
                                                                v-for="user of uncheckedUserStudents"
                                                                @click="connectUserStudent(user)"
                                                                style="margin-bottom: 10px">
                                                                <div>
                                                                    <b>{{ user.full_name }}</b
                                                                    ><br />
                                                                    <i>{{ user.email }}</i>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab
                        class="apprentice-tab"
                        :title="$t('school.teachers')">
                        <div class="row">
                            <div class="col-md-4">
                                <div
                                    class="card"
                                    style="padding: 5px">
                                    <div class="card-title text-center">
                                        {{ $t('school.linked_teachers') }} ({{ checkedTeachers.length }})
                                    </div>

                                    <div class="card-body">
                                        <ul>
                                            <li
                                                class="clickable-item"
                                                v-for="teacher of checkedTeachers"
                                                @click="detachTeacher(teacher)"
                                                style="margin-bottom: 10px">
                                                <div class="row">
                                                    <div class="col-md-10">
                                                        <b>{{ teacher.full_name }}</b>
                                                        <span
                                                            class="no-eck-id-warning"
                                                            v-if="!teacher.eck_id"
                                                            >{{ $t('school.no_eck_id') }}</span
                                                        ><br />
                                                        <i>(las) {{ teacher.email }}</i> <br />
                                                        <i>(pxm) {{ getUserEmail(teacher.user_id) }}</i>
                                                    </div>
                                                    <div class="col-md-2"><i class="fa fa-trash"></i></div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div
                                    class="card"
                                    style="padding: 5px">
                                    <div class="card-title text-center">
                                        {{ $t('school.linked_teachers') }} ({{ uncheckedTeachers.length }})
                                    </div>

                                    <div class="card-body">
                                        <ul>
                                            <li
                                                class="clickable-item"
                                                v-for="teacher of uncheckedTeachers"
                                                @click="selectTeacher(teacher)"
                                                :style="[
                                                    selectedTeacher && teacher.id === selectedTeacher.id
                                                        ? { 'background-color': 'green' }
                                                        : '',
                                                ]"
                                                style="margin-bottom: 10px">
                                                <div class="col-md-10">
                                                    <b>{{ teacher.full_name }}</b>
                                                    <span
                                                        class="no-eck-id-warning"
                                                        v-if="!teacher.eck_id"
                                                        >{{ $t('school.no_eck_id') }}</span
                                                    ><br />
                                                    <i>{{ teacher.email }}</i>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div
                                    class="card"
                                    style="padding: 5px">
                                    <div class="card-title text-center">
                                        {{ $t('school.unlinked_existing_teachers') }} ({{
                                            uncheckedUserTeachers.length
                                        }})
                                    </div>

                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-12 text-center">
                                                        <b>{{ $t('school.suggestions') }}</b>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul>
                                                            <li
                                                                class="clickable-item"
                                                                v-for="user of suggestedUserTeachers"
                                                                @click="connectUserTeacher(user)"
                                                                style="margin-bottom: 10px">
                                                                <div>
                                                                    <b>{{ user.full_name }}</b
                                                                    ><br />
                                                                    <i>{{ user.email }}</i>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div
                                                    class="row"
                                                    style="margin-top: 20px">
                                                    <div class="col-md-12 text-center">
                                                        <b>{{ $t('school.all_teachers') }}</b>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <ul>
                                                            <li
                                                                class="clickable-item"
                                                                v-for="user of uncheckedUserTeachers"
                                                                @click="connectUserTeacher(user)"
                                                                style="margin-bottom: 10px">
                                                                <div>
                                                                    <b>{{ user.full_name }}</b
                                                                    ><br />
                                                                    <i>{{ user.email }}</i>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab
                        class="apprentice-tab"
                        title="Imports">
                        <design-2021-school-las-import-component :las-location-in="lasLocationIn">
                        </design-2021-school-las-import-component>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-school-las-component',
    props: ['usersIn', 'studentsIn', 'teachersIn', 'lasLocationIn'],
    data() {
        return {
            selectedStudent: null,
            selectedTeacher: null,
            students: this.studentsIn,
            teachers: this.teachersIn,
            users: this.usersIn,
            lasLocation: this.lasLocationIn,
            tabIndex: 0,
        };
    },
    // todo what we do what selected students that were already selected?
    computed: {
        checkedStudents() {
            return this.students.filter((s) => !!s.user_id);
        },
        uncheckedStudents() {
            return this.students.filter((s) => !s.user_id);
        },
        uncheckedUserStudents() {
            return this.users.filter((user) => {
                if (user.type !== 'student') {
                    return false;
                }
                for (const student of this.students) {
                    if (student.user_id === user.id) {
                        return false;
                    }
                }
                return true;
            });
        },
        suggestedUserStudents() {
            if (!this.selectedStudent) {
                return [];
            }
            return this.usersIn.filter((u) => {
                if (u.type !== 'student') {
                    return false;
                }
                return (
                    u.name.toLowerCase() === this.selectedStudent.first_name.toLowerCase() ||
                    u.surname.toLowerCase() === this.selectedStudent.last_name.toLowerCase()
                );
            });
        },

        checkedTeachers() {
            return this.teachers.filter((s) => !!s.user_id);
        },
        uncheckedTeachers() {
            return this.teachers.filter((s) => !s.user_id);
        },
        uncheckedUserTeachers() {
            return this.users.filter((user) => {
                if (user.type !== 'teacher') {
                    return false;
                }
                for (const teacher of this.teachers) {
                    if (teacher.user_id === user.id) {
                        return false;
                    }
                }
                return true;
            });
        },
        suggestedUserTeachers() {
            if (!this.selectedTeacher) {
                return [];
            }
            return this.usersIn.filter((u) => {
                if (u.type !== 'teacher') {
                    return false;
                }
                return (
                    u.name.toLowerCase() === this.selectedTeacher.first_name.toLowerCase() ||
                    u.surname.toLowerCase() === this.selectedTeacher.last_name.toLowerCase()
                );
            });
        },
    },
    methods: {
        updateStudents(attached) {
            for (const student of attached) {
                for (const s of this.students) {
                    if (s.id === student.las_user_id) {
                        s.user_id = student.user_id;
                    }
                }
            }
        },
        updateTeacher(attached) {
            for (const teacher of attached) {
                for (const t of this.teachers) {
                    if (t.id === teacher.las_user_id) {
                        t.user_id = teacher.user_id;
                    }
                }
            }
        },
        showAttachByName() {
            this.$refs['attach-by-name'].show(this.tabIndex === 0 ? 'student' : 'teacher');
        },
        selectStudent(student) {
            if (this.selectedStudent) {
                if (student.id === this.selectedStudent.id) {
                    this.selectedStudent = null;
                    return;
                }
            }
            this.selectedStudent = student;
        },
        connectUserStudent(user) {
            if (!this.selectedStudent) {
                return;
            }
            this.alert.saving();
            this.axios.post(this.routes.lasAssignStudent(user.id, this.selectedStudent.id)).then(
                (response) => {
                    this.students = this.students.map((s) => {
                        if (s.id !== this.selectedStudent.id) {
                            return s;
                        }
                        let new_student = Object.assign({}, s);
                        new_student.user_id = user.id;
                        return new_student;
                    });
                    this.selectedStudent = null;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        detachStudent(student) {
            this.alert
                .confirm(
                    // TODO: Combine translations with parameter
                    this.$t('school.student') + student.full_name + this.$t('school.unlink'),
                    this.$t('school.are_you_sure_you_want_to_unlink_this_student'),
                    this.$t('school.unlink'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.post(this.routes.lasDetachStudent(student.id)).then(
                        (response) => {
                            this.students = this.students.map((s) => {
                                if (s.id !== student.id) {
                                    return s;
                                }
                                let new_student = { ...s };
                                new_student.user_id = null;
                                return new_student;
                            });
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        selectTeacher(teacher) {
            if (this.selectedTeacher) {
                if (teacher.id === this.selectedTeacher.id) {
                    this.selectedTeacher = null;
                    return;
                }
            }
            this.selectedTeacher = teacher;
        },
        connectUserTeacher(user) {
            if (!this.selectedTeacher) {
                return;
            }
            this.alert.saving();
            this.axios.post(this.routes.lasAssignEmployee(user.id, this.selectedTeacher.id)).then(
                (response) => {
                    this.teachers = this.teachers.map((s) => {
                        if (s.id !== this.selectedTeacher.id) {
                            return s;
                        }
                        let new_teacher = Object.assign({}, s);
                        new_teacher.user_id = user.id;
                        return new_teacher;
                    });
                    this.selectedTeacher = null;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        detachTeacher(teacher) {
            this.alert
                .confirm(
                    // TODO: Combine translations with parameter
                    this.$t('school.teacher') + teacher.full_name + this.$t('school.unlink'),
                    this.$t('school.are_you_sure_you_want_to_unlink_this_teacher'),
                    this.$t('school.unlink'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.post(this.routes.lasDetachEmployee(teacher.id)).then(
                        (response) => {
                            this.teachers = this.teachers.map((s) => {
                                if (s.id !== teacher.id) {
                                    return s;
                                }
                                let new_teacher = { ...s };
                                new_teacher.user_id = null;
                                return new_teacher;
                            });
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        checkSchool() {
            this.alert.saving();
            this.axios.post(this.routes.lasLocationChecked()).then(
                (response) => {
                    this.lasLocation.checked = true;
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        createUsers() {
            this.alert
                .confirm(
                    this.$t('school.create_users'),
                    this.$t('school.are_you_sure_you_want_to_create_users_for_all_unlinked_teachers_and_students'),
                    this.$t('school.create'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios.post(this.routes.lasLocationCreateUsers()).then(
                        (response) => {
                            this.students = response.data.students;
                            this.employees = response.data.employees;
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        getUserEmail(id) {
            for (const user of this.users) {
                if (user.id === id) {
                    return user.email;
                }
            }
        },
        updateLasLocation(lasLocation) {
            this.lasLocation = lasLocation;
            this.alert.success();
        },
    },
};
</script>

<style scoped>
.clickable-item {
    cursor: pointer;
}

.clickable-item:hover {
    background-color: lightgray;
}

.no-eck-id-warning {
    color: red;
}
</style>
